// @core/api/endpoints/team/remove_team_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/team';

/**
 * Remove team member
 * Removes a member from the team. The user loses access to team resources and their roles are revoked.
 */
export async function RemoveTeamMember(
  team_id: string,
  member_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/members/:member_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':member_id', encodeURIComponent(member_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
